
import { Client } from "../../types";
import { DollarSign, Users, MapPin } from "lucide-react";
import { FieldIndicator } from "./FieldIndicator";

interface KeyMetricsStatusSectionProps {
  client: Client;
  fieldsWithNewData: Set<keyof Client>;
}

export const KeyMetricsStatusSection: React.FC<KeyMetricsStatusSectionProps> = ({
  client,
  fieldsWithNewData,
}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-800 dark:text-slate-200 border-b pb-2">Key Metrics & Status</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
        <div>
          <h4 className="text-sm font-medium text-muted-foreground flex items-center">
            <DollarSign className="w-4 h-4 mr-2 text-invenio-primary" />
            Revenue Range
            <FieldIndicator fieldName="revenue_range" fieldsWithNewData={fieldsWithNewData} />
          </h4>
          <p className="text-sm">{client.revenue_range || "Not specified"}</p>
        </div>
        <div>
          <h4 className="text-sm font-medium text-muted-foreground flex items-center">
            <Users className="w-4 h-4 mr-2 text-invenio-primary" />
            Employee Count
            <FieldIndicator fieldName="employee_count" fieldsWithNewData={fieldsWithNewData} />
          </h4>
          <p className="text-sm">{client.employee_count || "Not specified"}</p>
        </div>
        <div>
          <h4 className="text-sm font-medium text-muted-foreground flex items-center">
            <MapPin className="w-4 h-4 mr-2 text-invenio-primary" />
            Geographic Area
            <FieldIndicator fieldName="geographic_area" fieldsWithNewData={fieldsWithNewData} />
          </h4>
          <p className="text-sm">{client.geographic_area || "Not specified"}</p>
        </div>
      </div>
    </div>
  );
};
